import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-field',
			dom: {
				input: '.js-field-input'
			},
			classes: {
				focus: 'field_focus',
				error: 'field_state_error'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.field = [];

		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);

		return this;
	}

	get() {
		const {input} = this.options.dom;

		this.fields = [...this.$el].map(field => ({
			$field: $(field),
			$input: $(field).find(input)
		}));

		return this;
	}

	onChange = field => () => {
		const {focus} = this.options.classes;
		const value = field.$input.val();
		const toggle = value.length > 0;
		field.$field.toggleClass(focus, toggle);
	}

	onFocus = field => () => {
		const {error} = this.options.classes;
		field.$field.removeClass(error);
	}

	onError = field => () => {
		const {error} = this.options.classes;
		field.$field.addClass(error);
	}

	init() {
		this.fields.forEach(field => {
			field.$input
				.on('blur', this.onChange(field))
				.on('focus', this.onFocus(field))
				.on('error', this.onError(field));
		});
	}

	render() {
		if (this.$el.length) {
			this
				.get()
				.init();
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/field/field.js